// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color } from "@flip/XDL/Utilities";
import { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { GridItemProps } from "@insite/mobius/GridItem";
import { css } from "styled-components";

interface MyAccountDetailsStyles {
    informationHeadingAndText?: SmallHeadingAndTextStyles;
    informationGridItem?: GridItemProps;
}

const myAccountDetailsStyles: MyAccountDetailsStyles = {
    informationHeadingAndText: {
        text: {
            size: 14,
            lineHeight: "22px",
            css: css`
                font-size: 14px;
                line-height: 22px;
            `,
        },
        heading: {
            variant: "h6",
            as: "h3",
            css: css`
                @media print {
                    font-size: 12px;
                }
                margin-bottom: 5px;
            `,
        },
    },
    informationGridItem: {
        width: [6, 6, 4, 4, 4],
        css: css`
            flex-direction: column;
            &:empty,
            &:has(> span:empty) {
                display: none;
            }
        `,
    },
};

export default myAccountDetailsStyles;
